import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React from 'react';

var _excluded = ["as", "background", "className"];
var LayoutSectionHeader = function LayoutSectionHeader(_ref) {
  var As = _ref.as,
    background = _ref.background,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (!React.Fragment) {
    console.error('[CANVAS UI] Layout.SectionHeader requires React.Fragment (React 16+). Please update your version of React or use a polyfill.');
    return null;
  }
  var backgroundFinalClasses = classnames('C-Layout__sectionHeaderBackground');
  var finalClasses = classnames('C-Layout__sectionHeader', {
    '--background': background
  }, className);
  return /*#__PURE__*/React.createElement(React.Fragment, null, background && /*#__PURE__*/React.createElement("div", {
    className: backgroundFinalClasses
  }), /*#__PURE__*/React.createElement(As, _extends({
    className: finalClasses
  }, otherProps)));
};
LayoutSectionHeader.displayName = 'Layout.SectionHeader';
LayoutSectionHeader.defaultProps = {
  as: 'div'
};

export { LayoutSectionHeader as default };
